export enum MotifSuspensionEnum {
  none = 0,
  autre = 1,
  sante = 2,
  impaye = 3,
  sansRsacRcp = 4,
  recouvrement = 5
}